/** Live feedback of a word ladder: the visible rules only, never the dictionary nor the key. */
import type { Feedback } from "../types";
import { partialIssues } from "./ladder";
import type { WordLadderDefinition, WordLadderProgress } from "./types";

export function localFeedback(
  definition: WordLadderDefinition,
  progress: WordLadderProgress,
): Feedback[] {
  return partialIssues(definition.start, definition.end, definition.maxSteps, progress.rungs).map(
    (issue) => ({
      type: "ladder",
      code: issue.code,
      cells: [],
      index: issue.index,
      params: { ...issue.params, ...(issue.word !== undefined ? { word: issue.word } : {}) },
    }),
  );
}
